module.exports = __webpack_public_path__ + "img/logoDriverSys.746d4be9.png";